import { useLingui } from '@lingui/react/macro';
import { useCallback } from 'react';
import { InterventionPanel } from '@/intervention/components/InterventionPanel';
import { useOpenSidePanel } from '@/ui/layout/side-panel/hooks/useOpenSidePanel';
import { type InterventionFieldsFragment } from '~/generated/graphql';
export const useOpenInterventionSidePanel = () => {
  const { t } = useLingui();
  const { openSidePanel } = useOpenSidePanel();
  const openInterventionSidePanel = useCallback(
    (
      intervention?: Pick<InterventionFieldsFragment, 'id' | 'title'>,
      options?: { forcedReadOnly?: boolean },
    ) => {
      openSidePanel({
        title: intervention?.title ?? t`Create intervention`,
        content: (
          <InterventionPanel
            interventionId={intervention?.id}
            forcedReadOnly={options?.forcedReadOnly}
          />
        ),
      });
    },
    [openSidePanel, t],
  );
  return { openInterventionSidePanel };
};
